export default __webpack_public_path__ + "pgnv-assets/3e11eef61ddb8bec6c3e785d60c5e5c5.png";